export const PLANS = {
  free: 'free',
  pro: 'pro',
  elite: 'elite',
};

export const FEATURES = {
  // TRADES
  unlimitedTrades:      ['pro', 'elite'],
  csvImport:            ['pro', 'elite'],
  contractNoteImport:   ['elite'],

  // REPORTS
  reportsOverview:      ['free', 'pro', 'elite'],
  reportsPerformance:   ['pro', 'elite'],
  reportsPsychology:    ['pro', 'elite'],
  reportsRisk:          ['pro', 'elite'],
  reportsSymbol:        ['pro', 'elite'],
  reportsWeekly:        ['pro', 'elite'],
  reportsMonthly:       ['pro', 'elite'],
  reportsExport:        ['pro', 'elite'],

  // AI
  aiChatUnlimited:      ['pro', 'elite'],
  aiChatBasic:          ['free', 'pro', 'elite'],
  smartAI:              ['pro', 'elite'],
  advancedPatternAI:    ['elite'],
  postTradeFeedback:    ['pro', 'elite'],
  lossStreakAlert:       ['pro', 'elite'],
  monthlyCoachingReport: ['elite'],

  // OTHER
  riskManager:          ['pro', 'elite'],
  psychologyTracker:    ['pro', 'elite'],
  affiliate:            ['pro', 'elite'],
  communityRead:        ['free', 'pro', 'elite'],
  communityFull:        ['pro', 'elite'],
  dataExport:           ['elite'],
  whatsappSupport:      ['elite'],
};

export const FREE_TRADE_LIMIT = 10;
export const FREE_AI_CHAT_LIMIT = 3;

export const hasFeature = (userPlan, feature) => {
  const allowed = FEATURES[feature];
  if (!allowed) return false;
  return allowed.includes(userPlan || 'free');
};

export const getPlanLevel = (plan) => {
  const levels = { free: 0, pro: 1, elite: 2 };
  return levels[plan] || 0;
};

export const isHigherPlan = (userPlan, requiredPlan) => {
  return getPlanLevel(userPlan) >= getPlanLevel(requiredPlan);
};
